if ( typeof jQuery !== 'function' ) {
	const message = 'pre-loader.jquery.js:\n' +
		'\t' + 'Missing \'jQuery\' library!';

	throw new Error( message );
}

jQuery(document).ready(function( $ ) {
	$.preLoader = {
		element : $( $( '.pre-loader' )[ 0 ] ),
		show    : function() {
			if ( this.element.hasClass( 'shown' ) ) {
				return this;
			}

			if ( this.element.attr( 'data-state' ) === 'in progress' ) {
				setTimeout( function() {
					$.preLoader.show();
				}, 50 );
			}
			else {
				this.element.removeClass( 'hidden' ).attr( 'data-state', 'in progress' );

				setTimeout( function() {
					$.preLoader.element.addClass( 'shown' );
					$( 'html' ).css( 'overflow', 'hidden' );
				}, 50 );

				setTimeout( function() {
					$.preLoader.element.attr( 'data-state', 'done' );
				}, 1000 + 50 );
			}

			return this;
		},
		hide    : function() {
			if ( this.element.hasClass( 'hidden' ) ) {
				return this;
			}

			if ( this.element.attr( 'data-state' ) === 'in progress' ) {
				setTimeout( function() {
					$.preLoader.hide();
				}, 50 );
			}
			else {
				this.element.removeClass( 'shown' ).attr( 'data-state', 'in progress' );

				setTimeout( function() {
					$.preLoader.element.addClass( 'hidden' );
				}, 50 );

				setTimeout( function() {
					$.preLoader.element.attr( 'data-state', 'done' );
					$( 'html' ).css( 'overflow', 'visible' );
				}, 1000 + 50 );
			}

			return this;
		},
		onload  : function() {
			setTimeout( function() {
				$.preLoader.element.addClass( 'document-loaded' );
			}, 1000 );

			return this;
		},
	};

	$( document ).ready( function() {
		setTimeout( function() {
			$.preLoader.hide().onload();
		}, 1000 );
	} );
});